import { useEffect } from "react";
import { QueryClient } from "@tanstack/react-query";
import {
  createRootRouteWithContext,
  Outlet,
  useRouter,
  useRouterState,
} from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";
import { NotFound } from "@/components/NotFound";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  notFoundComponent: NotFound,
  component: RootComponent,
});

function RootComponent() {
  const router = useRouter();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const matchWithTitle = [...router.state.matches]
    .reverse()
    .find((d) => d.routeContext?.title);
  const title = matchWithTitle?.routeContext.title || "Morgan";

  // Always land at the top of the destination page on navigation (e.g.
  // footer → /terms), rather than keeping the previous scroll position.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Outlet />
      <Helmet>
        <title>{title}</title>
      </Helmet>
    </>
  );
}
